import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 28 Mar 2026 22:35 PM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.deJk2f8pxaA40UzMeoufz9HNngaDXMzLWakTYBPFqCTbjSbppBBeTxnO8jJy1d2ka7ZZlw_drEoyYr3ZEIj_5OKOLpP80einqb_c30o1hhH-7XR7lu8DGxcC0d1_IxWBZfm5vMnegq7DGAw0G2KI0bMMY5GIGeQu0UZ-LlMaXT0-vfqEkvQPI-GyWx7Z5Qukgw-ias6IAXGfp65qHxsDV8REjOcEDGV3GB2MlNdGJUbVkFOSrPGXeZeZm7k_7VyfBffcSB1iLbGSHHTHw88_AEi6y1Fa9gFCYswPHHpp67vYrNeEvpPZp3dzFSAH_dwduN0sralgdiZrSDPS4lzaG_eZWjmQkTWd-A",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-11-06T14:57:18.143326Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-03-28T21:34:45+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.deJk2f8pxaA40UzMeoufz9HNngaDXMzLWakTYBPFqCTbjSbppBBeTxnO8jJy1d2ka7ZZlw_drEoyYr3ZEIj_5OKOLpP80einqb_c30o1hhH-7XR7lu8DGxcC0d1_IxWBZfm5vMnegq7DGAw0G2KI0bMMY5GIGeQu0UZ-LlMaXT0-vfqEkvQPI-GyWx7Z5Qukgw-ias6IAXGfp65qHxsDV8REjOcEDGV3GB2MlNdGJUbVkFOSrPGXeZeZm7k_7VyfBffcSB1iLbGSHHTHw88_AEi6y1Fa9gFCYswPHHpp67vYrNeEvpPZp3dzFSAH_dwduN0sralgdiZrSDPS4lzaG_eZWjmQkTWd-A'

// {
//   "access_token": "v2.local.7SKY5Dt0O8ZaKBTAWCkiQ8bf0m-mWYs63Qe46dbi7a-9X8ppGppKvn-2avO5m05M6O9dvpayOPUxvLlnuQl9JbB9uXUGg_EkwLsTz6IP3FP3sf4913tYiai7z4qw5ke3AhZUlpZsD8MJQ0MyKNK6mltWpqpikRhNBKbsawx7TbeufC31BhNuEPXOMUyl46-9LtLo9Edd-ObXCRd-vpIMjcMsTq5Udkn7ap15ZHOLlM0fFKB42o6VlUozy29eRPF2yNOTDonyaP0jEI6D-l8q_cSST10Rxdt9kNigAzef5C9Vy_yA6Zzotgc4eY6X3SszBXnvrtgJVe8XJkM4nQYC5gUnVYOB",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-11-06T14:57:18.442960Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-03-28T21:36:19+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.7SKY5Dt0O8ZaKBTAWCkiQ8bf0m-mWYs63Qe46dbi7a-9X8ppGppKvn-2avO5m05M6O9dvpayOPUxvLlnuQl9JbB9uXUGg_EkwLsTz6IP3FP3sf4913tYiai7z4qw5ke3AhZUlpZsD8MJQ0MyKNK6mltWpqpikRhNBKbsawx7TbeufC31BhNuEPXOMUyl46-9LtLo9Edd-ObXCRd-vpIMjcMsTq5Udkn7ap15ZHOLlM0fFKB42o6VlUozy29eRPF2yNOTDonyaP0jEI6D-l8q_cSST10Rxdt9kNigAzef5C9Vy_yA6Zzotgc4eY6X3SszBXnvrtgJVe8XJkM4nQYC5gUnVYOB'

// {
//   "access_token": "v2.local.9q3wA0PBOs76C5CPww53iaKEtVt1SCoOIhrG_DLu4mOqiy2BXuOLV5zP-riWtsLqEmtwqDRfM64L0k1HWS_3U8v-nP7n4iMA7cSQYY0Mf9iB2XcK_8GOF9jzTufoS4jluOXeF5RdYVkGlcP2L3cZGt0-tEumgP5TikZjKSEvEKoeR0L3ad5tZc5U68RnPnFOJ-OdE_A1zYfiudT_wLqBWtxMevft5WHRwSDIWWUScRAiaP0KkbEaMDAT0vVrKUFLKfaX0tUZWmxivCFTimtg-rOJC8s7wUlFavWN5FRlwWThtNtyDtz3ke-3Er8gcp_PknFu-c9MpV3EcGiNidjbia8ll3M",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-11-06T14:57:18.740571Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.9q3wA0PBOs76C5CPww53iaKEtVt1SCoOIhrG_DLu4mOqiy2BXuOLV5zP-riWtsLqEmtwqDRfM64L0k1HWS_3U8v-nP7n4iMA7cSQYY0Mf9iB2XcK_8GOF9jzTufoS4jluOXeF5RdYVkGlcP2L3cZGt0-tEumgP5TikZjKSEvEKoeR0L3ad5tZc5U68RnPnFOJ-OdE_A1zYfiudT_wLqBWtxMevft5WHRwSDIWWUScRAiaP0KkbEaMDAT0vVrKUFLKfaX0tUZWmxivCFTimtg-rOJC8s7wUlFavWN5FRlwWThtNtyDtz3ke-3Er8gcp_PknFu-c9MpV3EcGiNidjbia8ll3M'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
